module.exports = __webpack_public_path__ + "media/promo/velle/images/vkShare-c19a4f698d309028d7c957a07a143122.svg";